import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, Link } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
  CftTank,
} from "../../../components";
import routes from "../../../utils/cftRoutes";
import { useCft } from "../../../utils/CftProvider";

import SoilBothCalcForm, {
  SoilBothCalcFormContext,
} from "../../../forms/farmlands/bothCalc/SoilBothCalcForm/SoilBothCalc.form";

function SoilBothCalcPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveBothCalc, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={14}
          cropName={meta.title.bothCalc}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="bothCalc" />

              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveBothCalc({
                    soil: values,
                  });
                  history.push(routes.FARMLANDS.BOTH_CALC.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:soil.title", "Charakterystyka gleby")}
          onBack={() => history.push(routes.FARMLANDS.BOTH_CALC.DETAILS)}
          onNext={submitForm}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:soil.title", "Charakterystyka gleby")}</h3>
            <p>
              {t(
                "cft:soil.subtitle",
                "W swojej ocenie określ charakterystykę gleby na polu."
              )}
            </p>
            <p className="soil-page__article">
              {t(
                "cft:soil.article",
                "Jeśli nie wiesz, gdzie zodbyć informację o glebie, przejdź do artykułu"
              )}
              <Link to="/articles/obecny-system-badania-probek-gleb-w-polsce">
                {t(
                  "cft:soil.link",
                  "Czym jest i gdzie sprawdzę swoją charakterystykę gleby"
                )}
              </Link>
            </p>
          </>
        }
      >
        <SoilBothCalcForm />
        <CftReportProgress type="bothCalc" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <SoilBothCalcFormContext>
      <SoilBothCalcPage />
    </SoilBothCalcFormContext>
  );
};
